import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/globe.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/sticker.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/route.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/contours.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/page.module.css");
